import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import { spacing4, spacing12 } from 'approot/shared/styles/spacing.style';
import { baseBoxShadowFocus } from 'approot/shared/styles/borders.style';
import {
  grey1,
  grey5,
  grey6,
  grey7,
  purple7,
  purple6,
  purple8,
} from 'approot/shared/styles/colours.style';
import { PStyled } from 'approot/shared/styles/typography.style';

export const SwitchInactiveStyled = styled.div`
  display: flex;
  flex-basis: 50%;
  padding-right: ${rem(2)};
  justify-content: flex-end;
`;

export const SwitchActiveStyled = styled.div`
  display: flex;
  padding-left: ${rem(2)};
  flex-basis: 50%;
`;

export const SwitchStyled = styled.button`
  background-color: ${grey6};
  border: 2px solid ${grey6};
  border-radius: ${rem(32)};
  display: inline-flex;
  align-items: center;
  height: ${rem(24)};
  padding: ${rem(spacing4)};
  position: relative;
  width: ${rem(48)};

  &:hover {
    background-color: ${grey5};
    border-color: ${grey5};
    cursor: pointer;
  }

  &:focus {
    box-shadow: ${baseBoxShadowFocus};
    border-color: ${grey1};
    outline: 0;
  }

  &:active {
    background-color: ${grey7};
    border-color: ${grey7};
    box-shadow: none;
  }

  span {
    background-color: ${grey1};
    border-radius: 50%;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
    height: ${rem(16)};
    width: ${rem(16)};
    position: absolute;
    top: ${rem(2)};
    left: ${rem(2)};
    transition: all 200ms ease;
  }

  svg {
    stroke: ${grey1};
  }

  &[aria-checked='true'] {
    background-color: ${purple7};
    border-color: ${purple7};

    &:hover {
      background-color: ${purple6};
      border-color: ${purple6};
    }

    &:focus {
      box-shadow: ${baseBoxShadowFocus};
      border-color: ${grey1};
      outline: 0;
    }

    &:active {
      background-color: ${purple8};
      border-color: ${purple8};
      box-shadow: none;
    }

    span {
      left: ${rem(26)};
    }
  }

  &[aria-readonly='true'] {
    background-color: ${grey5};
    border-color: ${grey5};

    svg {
      stroke: ${grey6};
    }

    &:hover {
      background-color: ${grey5};
      border-color: ${grey5};
      cursor: not-allowed;
    }

    &:focus {
      box-shadow: ${baseBoxShadowFocus};
      border-color: ${grey1};
    }
  }
`;

export const SwitchLabel = styled(PStyled).attrs({
  as: 'span',
})`
  margin-left: ${rem(spacing12)};
`;
